import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import '../../../styleLess/signature/Taskdetail.scss'
import update from '../../../icons/Taskbox/updatestatus.svg'
import {
  ClockCircleOutlined,
  CloseCircleOutlined,
  HourglassOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Form, Input, DatePicker, Button, Modal, Dropdown, Menu, TimePicker } from 'antd'
const { RangePicker } = DatePicker
import more from '../../../icons/More.svg'
import { getCookie } from 'helper/cookie'
import {
  getListTaskStatus,
  addTaskStatus,
  updateTaskStatus,
  deleteTaskStatus,
} from 'api/TaskInbox/taskstatus'
import { getBlockHoliday } from 'api/MasterData/companyHoliday'
import moment, { months } from 'moment'
import { useParams } from 'react-router-dom'
const EmptyStateContainer = styled.div``
const NormalStateContainer = styled.div``
const Container = styled.div``
const BoxStatus = styled.div``
const initalState = {
  empty: '',
  data: [],
  isLoading: true,
}
const format = 'HH:mm'
const UpdateStatus = (props) => {
  const [Render, SetRender] = useState()
  const { planDate, hidden, duration, planStartDate, planEndDate, working_hour } = props
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isModalVisible2, setIsModalVisible2] = useState(false)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [dataTaskStatus, setDataTaskStatus] = useState(initalState.data)
  const [checkEvent, setCheckEvent] = useState(initalState.empty)
  const [statusId, setStatusId] = useState(initalState.empty)
  const [blockDate, setBlockDate] = useState()
  const token = getCookie('access_token_admin')
  const [startDate, setStartDate] = useState(planStartDate)
  const [endDate, setEndDate] = useState(planEndDate)
  const [workingHour, setWorkingHour] = useState('08:00')
  const { project_id, subtaskId } = useParams()
  //block holiday

  const blockHoliday = async () => {
    const data = {
      project_id: project_id,
    }
    await getBlockHoliday({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setBlockDate([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setBlockDate(data.block_date)
          await setIsLoading(false)
        } else {
          setBlockDate([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setBlockDate([])
        setIsLoading(false)
        console.error(error)
      })
  }

  ////    call api subtask by id
  const getListDataTaskStatus = async () => {
    const data = {
      project_id: project_id,
      sprintflow_id: subtaskId,
    }
    await getListTaskStatus({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataTaskStatus([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataTaskStatus(data)
          await setIsLoading(false)
          await SetRender(1)
        } else {
          await SetRender(0)
          setDataTaskStatus([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataTaskStatus([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getListDataTaskStatus()
      blockHoliday()
    }
  }, [token])

  const { TextArea } = Input
  const handleAddTaskStatus = () => {
    if (duration === 2) {
      const diffDayValue = calculateDate(moment(planStartDate), moment(planEndDate))
      form.setFieldsValue({
        working_day: diffDayValue,
      })
    }
    form.setFieldsValue({
      actual_date_form: [
        moment(planStartDate, 'YYYY-MM-DD'),
        moment(planEndDate, 'YYYY-MM-DD'),
      ],
      checkin_form: null,
      comment_form: null,
      problem_form: null,
      working_hours: moment(`${workingHour}`, 'HH:m'),
    })
    setIsModalVisible(true)
  }
  const handleEdit = (data) => {
    setCheckEvent('edit')
    setStatusId(data.id)
    if (duration === 1) {
      setStartDate(data.actual_date)
      setEndDate(data.actual_date_end)
      form.setFieldsValue({
        actual_date_form: [
          moment(data.actual_date, 'YYYY-MM-DD'),
          moment(data.actual_date_end, 'YYYY-MM-DD'),
        ],
        working_hours: moment(`${data.working_hour}`, 'HH:m'),
        comment_form: data.comment,
        problem_form: data.problem,
      })
    } else {
      if (data.actual_date_end) {
        setStartDate(data.actual_date)
        setEndDate(data.actual_date_end)
        form.setFieldsValue({
          actual_date_form: [
            moment(data.actual_date, 'YYYY-MM-DD'),
            moment(data.actual_date_end, 'YYYY-MM-DD'),
          ],
          working_day: data.working_day,
          comment_form: data.comment,
          problem_form: data.problem,
        })
      } else {
        form.setFieldsValue({
          working_day: data.working_day,
          comment_form: data.comment,
          problem_form: data.problem,
        })
      }
    }
    setIsModalVisible(true)
  }
  const handleDelete = (data) => {
    setStatusId(data.id)
    setIsModalVisible2(true)
  }
  const handleCancel = () => {
    form.setFieldsValue({
      actual_date_form: null,
      checkin_form: null,
      comment_form: null,
      problem_form: null,
      working_hours: null,
      working_day: null,
    })
    setCheckEvent(initalState.empty)
    setIsModalVisible(false)
  }
  const onDelete = () => {
    const data = {
      id: statusId,
      project_id: parseInt(project_id),
      sprintflow_id: parseInt(subtaskId),
    }
    try {
      deleteTaskStatus({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getListDataTaskStatus()
          setIsModalVisible2(false)
          props.getLogList()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  const cancle = () => {
    setIsModalVisible2(false)
  }
  const onFinish = (values) => {
    let data = {}
    if (['', null, undefined].includes(values.problem_form)) {
      values.problem_form = '-'
    }
    if (['', null, undefined].includes(values.comment_form)) {
      values.comment_form = '-'
    }
    if (checkEvent === 'edit') {
      if (duration === 1) {
        data = {
          id: statusId,
          project_id: parseInt(project_id),
          sprintflow_id: parseInt(subtaskId),
          problem: values.problem_form,
          comment: values.comment_form,
          actual_date: startDate,
          actual_date_end: endDate,
          working_hour: moment(values.working_hours, '00:00').format('HH:mm'),
        }
      } else {
        data = {
          id: statusId,
          project_id: parseInt(project_id),
          sprintflow_id: parseInt(subtaskId),
          problem: values.problem_form,
          comment: values.comment_form,
          actual_date: startDate,
          actual_date_end: endDate,
        }
      }
      try {
        updateTaskStatus({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getListDataTaskStatus()
            props.getLogList()
          }
          setCheckEvent(initalState.empty)
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      if (duration === 1) {
        data = {
          project_id: parseInt(project_id),
          sprintflow_id: parseInt(subtaskId),
          problem: values.problem_form,
          comment: values.comment_form,
          actual_date: moment(values.actual_date_form[0]).format('YYYY-MM-DD'),
          actual_date_end: moment(values.actual_date_form[1]).format('YYYY-MM-DD'),
          working_hour: moment(values.working_hours, '00:00').format('HH:mm'),
        }
      } else {
        data = {
          project_id: parseInt(project_id),
          sprintflow_id: parseInt(subtaskId),
          problem: values.problem_form,
          comment: values.comment_form,
          actual_date: moment(values.actual_date_form[0]).format('YYYY-MM-DD'),
          actual_date_end: moment(values.actual_date_form[1]).format('YYYY-MM-DD'),
        }
      }
      try {
        addTaskStatus({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getListDataTaskStatus()
            props.getLogList()
          }
          // setIsModalVisible(false)
        })
      } catch (error) {
        console.log(error)
      }
    }
    setIsModalVisible(false)
  }

  const onFinishFailed = (errorInfo) => {}
  const [form] = Form.useForm()
  const calculateDate = (actual_date, actual_date_end) => {
    const diffTime = Math.abs(actual_date - actual_date_end)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays + 1
  }
  const onChangeActualDate = (value, dateString) => {
    if (dateString[0] || dateString[1]) {
      setStartDate(dateString[0])
      setEndDate(dateString[1])
      const actual_date = moment(dateString[0])
      const actual_date_end = moment(dateString[1])
      // const diffTime = Math.abs(actual_date - actual_date_end)
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      const diffDayValue = calculateDate(actual_date, actual_date_end)
      form.setFieldsValue({
        working_day: diffDayValue,
      })
    } else {
      setStartDate(startDate)
      setEndDate(endDate)
      form.setFieldsValue({
        working_day: null,
      })
    }
  }
  const onchangeTime = (time) => {
    let hours = moment(time, '00:00').format('HH:mm')
    if (hours === '00:00') {
      form.setFieldsValue({
        working_hours: null,
      })
    }
  }
  function disabledDate(current) {
    if (planDate) {
      return (
        (current && current < moment(planDate.kickoff)) ||
        current >= moment().subtract(0, 'days')
      )
    }
  }
  const menu = (data) => {
    return (
      <Menu style={{ width: 140 }}>
        <Menu.Item key="0" onClick={() => handleEdit(data)}>
          Edit
        </Menu.Item>
        <Menu.Item key="1" onClick={() => handleDelete(data)}>
          Delete
        </Menu.Item>
      </Menu>
    )
  }

  const playState = () => {
    if (Render == 1) {
      return NormalState()
    } else if (Render == 0) {
      return EmptyState()
    }
  }
  const EmptyState = () => {
    return (
      <EmptyStateContainer className="EmptyStateContainer">
        <img className="img-emptystate big-icons" src={update}></img>
        <h2>Please update your task status</h2>
        <Button
          id="btn_updateStatus"
          className="BTN_Next"
          onClick={() => handleAddTaskStatus()}
          hidden={hidden}
        >
          <PlusOutlined className="Icon-color"></PlusOutlined>
          Update Status
        </Button>
      </EmptyStateContainer>
    )
  }
  const NormalState = () => {
    return (
      <NormalStateContainer className="updatestatus-container-item">
        <div className="BTN-container" style={{ width: '100%' }}>
          <Button
            id="btn_updateStatus"
            className="BTN_Next"
            onClick={() => handleAddTaskStatus()}
            hidden={hidden}
          >
            <PlusOutlined className="Icon-color" />
            Update Status
          </Button>
        </div>

        {dataTaskStatus.map((item, index) => (
          <BoxStatus className="BoxStatus">
            <div className="Body">
              <div className="Acon">
                <div className="sub-acon-responsive">
                  <div className="responsive-acon margin-edit-bottom">
                    <UserOutlined className="icon-color-style" />
                    <div style={{ display: 'grid' }}>
                      <span className="small cutter-text-line-1">
                        {item.account_name}
                      </span>
                    </div>
                  </div>
                  <div className="responsive-acon acon-date-and-hours">
                    {showDate(item)}
                    {showHoursDays(item)}
                    <div
                      className="margin-edit-bottom"
                      hidden={item.working_hour ? false : true}
                    >
                      <PlayCircleOutlined className="icon-color-style" />
                      <span className="small">
                        {item.working_totalhour ? item.working_totalhour : 0} hours
                      </span>
                    </div>
                  </div>
                </div>
                <div hidden={hidden} className="showmore-container-responsive">
                  <Dropdown
                    overlay={(e) => menu(item)}
                    trigger={['click']}
                    placement="bottomRight"
                  >
                    <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                      <img src={more} />
                    </a>
                  </Dropdown>
                </div>
              </div>
              <div className="Bcon">
                <div>
                  <span className="small">Problem</span>
                  <p className="margin cutter-text-line-multi">{item.problem}</p>
                </div>
                <div>
                  <span className="small">Comment</span>
                  <p className="cutter-text-line-multi">{item.comment}</p>
                </div>
              </div>
            </div>
            <div hidden={hidden} className="showmore-container">
              <Dropdown
                overlay={(e) => menu(item)}
                trigger={['click']}
                placement="bottomRight"
              >
                <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                  <img src={more} />
                </a>
              </Dropdown>
            </div>
          </BoxStatus>
        ))}

        <Modal
          maskClosable={false}
          className="DeleteModal"
          visible={isModalVisible2}
          onOk={onDelete}
          okText="Delete"
          onCancel={cancle}
          cancelText="Cancel"
        >
          <CloseCircleOutlined className="CloseCircleOutlined" />
          <h2>Are you sure ?</h2>
          <h4>Are you sure you want to delete this status ?</h4>
        </Modal>
      </NormalStateContainer>
    )
  }
  const hoursDays = () => {
    if (duration === 1) {
      return (
        <div className="right" style={{ marginLeft: 10 }}>
          <h4>Working Hours/day</h4>
          <Form.Item
            id="working_hours"
            name="working_hours"
            rules={[
              {
                required: true,
                message: '*Please enter your working hours',
              },
            ]}
          >
            <TimePicker
              id="working_hours"
              style={{ width: '100%' }}
              format={format}
              size="large"
              placeholder="Hours"
              onOk={onchangeTime}
            />
          </Form.Item>
        </div>
      )
    } else {
      return (
        <div className="right">
          <h4>Working Day</h4>
          <Form.Item id="working_day" name="working_day">
            <Input
              size="large"
              style={{ borderRadius: '5px' }}
              placeholder="Day"
              readOnly
            />
          </Form.Item>
        </div>
      )
    }
  }
  const showHoursDays = (item) => {
    if (item.working_hour) {
      return (
        <div className="hours-margin responsive-acon margin-edit-bottom">
          <HourglassOutlined className="icon-color-style" />
          <span className="small">{item.working_hour} hours/day</span>
        </div>
      )
    } else {
      return (
        <div className="hours-margin margin-edit-bottom">
          <HourglassOutlined className="icon-color-style" />
          <span className="small">{item.working_day} Days</span>
        </div>
      )
    }
  }
  const showDate = (item) => {
    if (duration === 1) {
      return (
        <div className="margin-edit-bottom">
          <ClockCircleOutlined className="icon-color-style" />
          <span className="small">
            {moment(item.actual_date).format('DD/MM/YYYY')}
            {' - '}
            {moment(item.actual_date_end).format('DD/MM/YYYY')}
          </span>
        </div>
      )
    } else {
      return (
        <div className="margin-edit-bottom">
          <ClockCircleOutlined className="icon-color-style" />
          <span className="small">
            {moment(item.actual_date).format('DD/MM/YYYY')}
            {' - '}
            {moment(item.actual_date_end).format('DD/MM/YYYY')}
          </span>
        </div>
      )
    }
  }
  return (
    <Container>
      {playState()}
      <Form
        name="updataStatus"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Modal
          maskClosable={false}
          className="ModalNormal "
          title="Update Status"
          visible={isModalVisible}
          onOk={form.submit}
          okText="Update"
          onCancel={handleCancel}
          destroyOnClose
        >
          <div className="body-layout-modal">
            <div className="actual-and-working-container">
              <div className="left">
                <h4>Actual date</h4>
                <Form.Item
                  id="actual_date_form"
                  name="actual_date_form"
                  rules={[
                    {
                      required: true,
                      message: '*Please enter your actual date',
                    },
                  ]}
                >
                  <RangePicker
                    dateRender={(current) => {
                      const style = {}
                      blockDate?.map((holiday) => {
                        if (
                          current.date() === holiday.day &&
                          current.month() === holiday.month - 1 &&
                          current.year() === holiday.year
                        ) {
                          style.color = '#FF6258'
                          style.fontWeight = 'bold'
                        }
                      })
                      return (
                        <div className="ant-picker-cell-inner" style={style}>
                          {current.date()}
                        </div>
                      )
                    }}
                    className="DatePicker"
                    id="kick_off_date"
                    name="kick_off_date"
                    onChange={onChangeActualDate}
                    // disabledDate={disabledDate}
                    format="YYYY-MM-DD"
                    size="large"
                  />
                </Form.Item>
              </div>

              {hoursDays()}
            </div>
            <h4>Problem</h4>
            <Form.Item id="problem_form" name="problem_form">
              <TextArea
                id="problem"
                name="problem"
                placeholder="Problem"
                autoSize={{ minRows: 3 }}
                style={{ borderRadius: '5px' }}
              />
            </Form.Item>
            <h4>Comment</h4>
            <Form.Item id="comment_form" name="comment_form">
              <TextArea
                id="comment"
                name="comment"
                placeholder="Comment"
                type="text"
                autoSize={{ minRows: 3 }}
                style={{ borderRadius: '5px' }}
              />
            </Form.Item>
          </div>
        </Modal>
      </Form>
    </Container>
  )
}

export default UpdateStatus
